import styled from 'styled-components'

export const CoreLayoutWrapper = styled.div`
  min-height: 100%;
  display: flex;
  flex-direction: column;
  flex: 1 0 auto;
`
